import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { IframeDmDanceCoursesPageComponent } from './iframe-dm-dance-courses-page.component';
import {
  CourseListItemCardModule,
  DanceEventPreviewCardModule,
  SharedEmptyPageModule
} from '@platri/dfx-angular-core';
import { TranslocoDirective } from '@jsverse/transloco';

const routes: Routes = [
  {
    path: '',
    component: IframeDmDanceCoursesPageComponent
  }
];

@NgModule({
  declarations: [IframeDmDanceCoursesPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    DanceEventPreviewCardModule,
    SharedEmptyPageModule,
    TranslocoDirective,
    CourseListItemCardModule
  ],
  exports: [IframeDmDanceCoursesPageComponent]
})
export class IframeDmDanceCoursesPageModule {

  constructor() {
    console.log('IframeDmDanceEventsPageModule initialized');
  }
}
